// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sQmC","col":"styles_col__-EZNF"};